import { UserFragment } from '../../generated';

export const isUserLinkedToBuyerOrSupplier = (user?: UserFragment | null) => {
  return Boolean(
    user?.linkedSupplier || (user?.buyers?.edges ?? []).length >= 1
  );
};
